// src/utils/obfSecret.ts
//
// ============================================================================
// DISABLED — VAPT finding #2 (Encryption Bypass / Client-Side Encryption Weakness)
// ============================================================================
// This file shipped the AES key and IV inside main.js. The pentester downloaded
// the bundle, read OBF_KEY_PARTS / OBF_IV_PARTS / OBF_MASK plus the decoder below
// them, reconstructed the key d93c5dc3c6a494235aaa39a856f95a07, and decrypted live
// API responses.
//
// The obfuscation never helped: the browser must reconstruct the real key to call
// crypto.subtle.importKey, so a breakpoint recovers it regardless of the wrapper.
//
// All key material is commented out. Transport encryption now uses the session-key
// scheme in Services/secureTransport.ts — a random AES-256 key per page load,
// RSA-OAEP wrapped to the server's public key in the x-session-key header. Nothing
// secret ships in the bundle; the RSA PUBLIC key cannot decrypt anything.
//
// The exports below remain only so the ~26 modules importing `aesKey` / `iv` keep
// compiling. They return empty strings and must not be used to encrypt anything.
// ============================================================================

/* ---------- obfuscated data — REMOVED, do not restore ----------
export const OBF_KEY_PARTS = ['g2YHmQ==', 'nP7OeQ==', 'APBj8g==', 'DKMAXQ==']
export const OBF_IV_PARTS = ['DG0Kcg==', 'CHwmcw==', 'NysBBA==', 'Lzh3Zg==']
export const OBF_MASK = 90
---------------------------------------------------------------- */

/** DISABLED — returns ''. Use Services/secureTransport instead. */
export function getAesKeyHex(): string {
  return ''
}

/** DISABLED — returns ''. The session-key scheme generates a random IV per message. */
export function getIvString(): string {
  return ''
}
